import { baseArkhaleAPI } from './base-api'
import { Pagination } from '../../shared/models/others/pagination'
import ApiKey, { ApiKeyResult } from '../../shared/models/api-key.model'
import { ApiKeyQuery, formatSortOrder } from './query-type'

const apiKeyApi = baseArkhaleAPI.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    getApiKeys: build.query<Pagination<ApiKey>, ApiKeyQuery>({
      query: (args) => {
        return {
          url: 'api-keys',
          method: 'GET',
          params: {
            offset: args.offset,
            limit: args.limit,
            textSearch: args.textSearch,
            ...formatSortOrder(args.sortOrder),
          },
        }
      },
    }),
    addApiKey: build.mutation<
      ApiKeyResult,
      Pick<ApiKey, 'id' | 'isActive' | 'projectID' | 'projectName' | 'userID'>
    >({
      query: (apiKey) => ({
        url: 'api-keys',
        method: 'POST',
        body: apiKey,
      }),
      invalidatesTags: [{ type: 'ApiKey', id: 'LIST' }],
    }),
  }),
})

export const { useLazyGetApiKeysQuery, useAddApiKeyMutation } = apiKeyApi

export default apiKeyApi
